import { usePathname, useRouter } from "next/navigation";
import NProgress from "nprogress";
import { useCallback } from "react";

const useProductOptions = (
  productOptions,
  parentSlug,
  locale,
  categorySlug,
  spaceSlug
) => {
  const router = useRouter();
  const pathname = usePathname();

  const isProductInInfluencerSetup = pathname?.includes("setup");
  const isProductInInfluencer = pathname?.includes("spaces");

  const getBasePath = useCallback(() => {
    if (!categorySlug) return "";
    if (isProductInInfluencerSetup) {
      return `/spaces/${spaceSlug}/setup/${categorySlug}/products`;
    }
    if (isProductInInfluencer) {
      return `/spaces/${categorySlug}/products`;
    }
    return `/collections/${categorySlug}/products`;
  }, [
    categorySlug,
    isProductInInfluencer,
    isProductInInfluencerSetup,
    spaceSlug,
  ]);

  const handleVariantSelection = useCallback(
    (attributeSlug, optionSlug) => {
      // Update the selectedAttributes string based on the selected option and value
      const updatedAttributes = Array.isArray(productOptions)
        ? productOptions.map((option) => {
            const selected =
              option.slug === attributeSlug
                ? optionSlug
                : option.values?.find((value) => value.selected)?.slug || "";
            return selected?.replace(/\s+/g, "");
          })
        : [];

      const newSelectedString = updatedAttributes.join("-");

      const variantUrl = `/${locale}${getBasePath()}/${parentSlug}-${newSelectedString}?parentSlug=${parentSlug}`;

      NProgress.start();
      router.replace(variantUrl);
    },
    [productOptions, locale, parentSlug, getBasePath, router]
  );

  return {
    handleVariantSelection,
  };
};

export default useProductOptions;
